module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Heart-8d8155cb88b1ddfd1807935072a30147.svg";